import { capitalize } from './capitalize';

const getPageTypeInternal = (parts: string[], options: { notFound?: boolean; isTenantDomain?: boolean }) => {
  // Page not found
  if (options.notFound) return '404 · Page not found';

  // Gallery
  if (parts[0] === 'a' && parts[1] === 'gallery') {
    if (parts[2] === 'create') {
      return 'Creating Gallery';
    } else {
      const mode = parts[3];
      let title = `Edit gallery · ${capitalize(mode)}`;
      if (parts.length === 5) title += ' · Asset';
      return title;
    }
  }

  if (parts[0] == 'gallery') {
    // View gallery

    // gallery access
    if (parts[1] === 'access') {
      return 'Gallery · Access';
    }

    // gallery identify
    if (parts[1] === 'identify') {
      return 'Gallery · Identify';
    }

    // gallery not found
    if (parts[1] === 'not-found') {
      return 'Gallery · Not found';
    }
    // gallery error
    if (parts[1] === 'error') {
      return 'Gallery · Error';
    }

    // gallery unsubscribe
    if (parts[2] === 'unsubscribe') {
      return 'Gallery · Unsubscribe';
    }
    // gallery subscribe
    if (parts[2] === 'subscribe') {
      return 'Gallery · Subscribe';
    }

    let title = `Gallery`;
    if (parts.length === 4) title += ' · Asset';
    return title;
  }

  // Home page
  if (parts[0] === '' && parts.length === 1) {
    if (options.isTenantDomain) return 'Tenant Profile';
    return 'Home';
  }

  // Galleries
  if (parts[1] === 'galleries') {
    if (!parts[2]) return 'Galleries';
    if (parts[2] === 'user') return 'Galleries · User';
    if (parts[2] === 'favorites') return 'Galleries · Favorites';
    if (parts[2] === 'shared') return 'Galleries · Shared';
    if (parts[2].startsWith('fold_')) return 'Galleries · Folder';
  }

  // Tenant select
  if (parts[0] === 'a' && parts[1] === 'workspaces') {
    return 'Choose Workspace';
  }

  // Settings
  if (parts[1] === 'settings') {
    return parts[2].split('-').map(capitalize).join(' ');
  }

  // Integrations
  if (parts[1] === 'access') {
    return `Access · ${capitalize(parts[2])}`;
  }

  // Activity
  if (parts[1] === 'activity') {
    return 'Activity';
  }

  // Accept invite
  if (parts[1] === 'accept-invite') {
    return 'Invitation';
  }

  // Accept invite
  if (parts[1] === 'not-invited') {
    return 'Not Invited';
  }

  if (parts[1] === 'confirm-change-email') {
    return 'Confirming';
  }

  if (parts[1] === 'access-denied') {
    return 'Acces Denied';
  }

  // Onboarding
  if (parts[1] === 'onboarding') {
    return 'Onboarding';
  }

  // Blog
  if (parts[0] === 'blog') {
    if (parts[1]) return 'Blog · Post';
    return 'Blog';
  }

  // Blog
  if (parts[0] === 'learn') {
    if (parts[1]) return 'Learn Picflow · Post';
    return 'Learn Picflow';
  }

  // Auth
  if (parts[0] === 'auth') {
    if (parts[1] === 'login') return 'Login';
    if (parts[1] === 'signup') return 'Sign up';
    if (parts[1] === 'password-reset') {
      if (parts[2] === 'sent') return 'Password reset · Sent';
      return 'Password reset';
    }
    if (parts[1] === 'authorize') return 'Authorizing';
  }

  // Checkout
  if (parts[0] === 'a' && parts[1] === 'pricing') return 'Pricing';
  if (parts[0] === 'a' && parts[1] === 'checkout') return 'Checkout';

  // Promo page
  if (parts[0] === 'promo') return 'Promo';

  // Confirmation
  if (parts[0] === 'a' && parts[3] === 'success') return 'Confirmation';
  if (parts[0] === 'a' && parts[1] === 'cancellation') return 'Confirmation';

  // Gallery not found page
  if (parts[0] === 'cant-edit-gallery') {
    return 'Gallery not Found';
  }

  // Gallery not found page but the user is logged in
  if (parts[1] === 'cant-edit-gallery') {
    return 'Gallery not Found';
  }

  if (parts[0] === 'press') {
    if (!parts[1]) return 'Press';
    if (parts[1] === 'branding') return 'Press · Branding';
    if (parts[1] === 'product') return 'Press · Product';
    if (parts[1] === 'coverage') return 'Press · Coverage';
    if (parts[1] === 'contact') return 'Press · Contact';
  }

  if (parts[0] === 'a' && parts[1] === 'help') return 'Help';
  if (parts[0] === 'a' && parts[1] === 'cancelled') return 'Subscription Cancelled';

  if (parts[0] === 'not-found') return 'Page not found';

  if (parts[parts.length - 1] === 'maintenance') return 'Maintenance';

  // Assuming any page that is not handled and not in the list is a landing page
  if (!['a', 'gallery'].includes(parts[0])) return 'Landing page';
};

export const getPageType = (url: string, options: { notFound?: boolean; isTenantDomain?: boolean }) => {
  const parts = url.split('?')[0].split('#')[0].split('/');
  parts.shift();

  let type = getPageTypeInternal(parts, options);
  if (type) {
    if (parts[0] === 'a') type += ' · Picflow';
    return type;
  }

  console.log(url, parts);

  // falling back to the page url
  return url;
};
